module.exports = __webpack_public_path__ + "img/ot-qiavax.5c29c745.png";